module.exports = __webpack_public_path__ + "img/ascend_gold3.1ed2c1fa.png";